<script lang="ts">
	import { onMount } from "svelte";

	import Introduction from "./Introduction.svelte";
	import InspirationAndBackground from "./InspirationAndBackground.svelte";
	
	import Reverie from "./Reverie.svelte";
	import StatsWeb from "../common/StatsWeb.svelte";
	import About from "./About.svelte";
	import PdfHolder from "./PdfHolder.svelte";
	import { getCanvasMaxSize } from '../common/helpers.js';

	export let hash: string;

	import GeneratePieceOfArt from "../common/GeneratePieceOfArt.svelte";
	
	let width: number;
	onMount(async () => {
		width = getCanvasMaxSize("#artSection");
	});
</script>

<main class="container">
	<section>
		<Introduction />
	</section>

	<section>
		<InspirationAndBackground />
	</section>

	<section id="artSection">
		<h1>A random final Reverie</h1>
		<Reverie {width} height={width} {hash} />
	</section>

	<GeneratePieceOfArt {hash}/>

	<section>
		<h1>Stats explained</h1>
		<StatsWeb />
	</section>

	<section>
		<h1>Vector rendering for risograph printing</h1>
		<PdfHolder {hash} />
	</section>

	<section>
		<h1>About Reverie and Pandelune</h1>
		<About />
	</section>

	<footer>
		<span id="copyright"
			>&copy; Copyright 2024, Pandelune. All the content is under copyright,
			including the source code of "Reverie".</span
		>
	</footer>
</main>
